export const AUTH_COOKIE = 'FOXKITAUTHN_WEB';
export const FOXAUTHXID = 'FOXAUTHXID';
export const XID_COOKIE = 'xid';
export const CCPA_VERIFIED_COOKIE = 'ccpa-verified';
export const CCPA_PRIVACY_COOKIE = 'us_privacy';

export const DEBUG_PANEL_AD_DEBUG = 'DEBUG_PANEL_AD_DEBUG';
export const DEBUG_PANEL_AD_SITE_SECTION = 'DEBUG_PANEL_AD_SITE_SECTION';

export const CENTRALIZED_LOGIN_IS_AUTHENTICATED = 'centralized_login_is_authenticated';
